<template>
  <card-component title="Şifre Güncelleme" icon="lock">
    <form @submit.prevent="submit">
      <b-field horizontal label="Mevcut Şifre">
        <b-input
          v-model="form.password_current"
          type="password"
          icon="lock-question"
          placeholder="Mevcut Şifre"
          validation-message="Mevcut şifrenizi giriniz."
          required
        />
      </b-field>
      <hr>
      <b-field horizontal label="Yeni Şifre">
        <b-input
          v-model="form.password"
          type="password"
          icon="lock-question"
          placeholder="Yeni Şifre"
          validation-message="Yeni şifrenizi giriniz."
          required
        />
      </b-field>
      <b-field horizontal label="Yeni Şifre (Tekrar)">
        <b-input
          v-model="form.password_confirmation"
          type="password"
          icon="lock-question"
          placeholder="Yeni Şifre (Tekrar)"
          validation-message="Yeni şifrenizi doğrulayınız."
          required
        />
      </b-field>
      <hr>
      <b-field horizontal>
        <div class="control">
          <button type="submit" class="button is-primary" :class="{'is-loading':isLoading}">
            Güncelle
          </button>
        </div>
      </b-field>
    </form>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
export default {
  name: 'PasswordUpdateForm',
  components: {
    CardComponent
  },
  data () {
    return {
      isLoading: false,
      form: {
        password_current: null,
        password: null,
        password_confirmation: null,
      }
    }
  },
  methods: {
    submit () {
      if (!this.validate(this.form)) {
        return this.$buefy.toast.open({
          message: 'Lütfen bilgilerinizi doğru giriniz.',
          type: 'is-danger',
          queue: false,
        })
      }

      this.isLoading = true

      this.$http.put('profile/password', this.form).then(({ data }) => {
        if (data.success) {
          this.$buefy.toast.open({
            message: 'Profiliniz başarıyla güncellendi.',
            type: 'is-success',
            queue: false,
          })
        }
      }).catch(({ response }) => {
        const errors = this.$_.flattenDeep(this.$_.values(response.data.error.errors)).join('<br>')
        this.$buefy.toast.open({
          message: errors,
          type: 'is-danger',
          duration: 5000,
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
    validate (data) {
      if (!data.password_current || data.password !== data.password_confirmation) {
        return false
      }

      return true
    },
  }
}
</script>
